module.exports = __webpack_public_path__ + "img/facebook.d6404a2.png";